import imageSomos from "../images/icons/baseline-person-search.svg"
import imageQueHacemos from "../images/icons/microbiology-sharp.svg"
import imageComoHacemos from "../images/icons/laboratory.svg"


export const InformativeMessages = {
   quienesSomos: {
       imagePath: `${imageSomos}`,
       title: "¿Quiénes somos?",
       content: "Somos una empresa de base tecnológica dedicada a la producción de compuestos nanotecnológicos por rutas verdes, amigables con el medio ambiente para diversas aplicaciones en la agroindustria, industria pecuaria, sector textil, calzado y construcción civil." 
   },

   queHacemos: {
       imagePath: `${imageQueHacemos}`,
       title: "¿Qué hacemos?",
       content: "Somos una plataforma colombiana de carácter bionanotecnológica dedicada a resolver problemas industriales relacionadas con la contaminación ocasionada por microorganismos como, hongos, virus y bacterias. Nuestra experticia académica y científica permite ofrecer al mercado productos tecnológicos adaptados a los requerimientos de la industria." 
    },

    comoHacemos: {
        imagePath: `${imageComoHacemos}`,
        title: "¿Cómo lo hacemos?",
        content: "Pretendemos convertirnos en ser el mayor proveedor de nanocompuestos sintetizados por rutas verdes para Colombia y países de Latinoamérica." 
    },
}